import Slab from "../Slab/Slab";
import { IPrivateMessageList } from "../../types/types";

interface ChatListProps {
  FanChats: IPrivateMessageList[];
  Chats: IPrivateMessageList[];
  HistoryChats: IPrivateMessageList[];
  selected: string;
  onSelect: (id: IPrivateMessageList) => void;
}

const ChatList: React.FC<ChatListProps> = ({
  FanChats,
  Chats,
  HistoryChats,
  selected,
  onSelect,
}) => {
  return (
    <div className=" recent-chats shadow-box">
      {Object.keys(FanChats).length > 0 && (
        <>
          <div className="font-500-20 mb-3">Fan1</div>
          {FanChats.map((data, index) => (
            <Slab
              onClick={() => onSelect(data)}
              key={data.id}
              className={` ${index === 0 ? "pb-1" : "py-1"}`}
              bgcolor={`${data.id === selected ? "active" : "bg-midnight"}`}
              content={
                <>
                  {data.image_url ? (
                    <img
                      src={data.image_url}
                      alt={data.name}
                      className="img-fluid chat-image user-img"
                    />
                  ) : (
                    <div
                      style={{ borderRadius: "4px 4px 0px 0px" }}
                      className={`default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center mx-auto chat-image ${
                        data.id === selected && "active-chat"
                      }`}
                    >
                      <i
                        className="fa-solid fa-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </div>
                  )}
                  <div
                    className={`chat-info d-flex align-items-center my-auto ${"light-purple-color"}`}
                  >
                    {data.is_read ? <div className="chat-active"></div> : null}
                    <div className="font-500-20 mb-0 ms-4">@{data.name}</div>
                  </div>
                </>
              }
            />
          ))}
        </>
      )}
      {Object.keys(Chats).length > 0 && (
        <>
          <div
            className={`font-500-20 mb-2 ${
              Object.keys(FanChats).length > 0 && "mt-4"
            }`}
          >
            Active Memberships
          </div>
          {Chats.map((data, index) => (
            <Slab
              onClick={() => onSelect(data)}
              key={data.id}
              className={` py-1`}
              bgcolor={`${data.id === selected ? "active" : "bg-midnight"}`}
              content={
                <>
                  {data.image_url ? (
                    <img
                      src={data.image_url}
                      alt={data.name}
                      className="img-fluid chat-image user-img"
                    />
                  ) : (
                    <div
                      style={{ borderRadius: "4px 4px 0px 0px" }}
                      className={`default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center mx-auto chat-image ${
                        data.id === selected && "active-chat"
                      }`}
                    >
                      <i
                        className="fa-solid fa-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </div>
                  )}
                  <div
                    className={`chat-info d-flex align-items-center my-auto ${"light-purple-color"}`}
                  >
                    {data.is_read ? <div className="chat-active"></div> : null}
                    <div className="font-500-20 mb-0 ms-4">{data.name}</div>
                  </div>
                </>
              }
            />
          ))}
        </>
      )}
      {Object.keys(HistoryChats).length > 0 && (
        <>
          <div
            className={`font-500-20 mb-2 ${
              (Object.keys(FanChats).length > 0 ||
                Object.keys(Chats).length > 0) &&
              "mt-4"
            }`}
          >
            Inactive Memberships
          </div>
          {HistoryChats.map((data, index) => (
            <Slab
              onClick={() => onSelect(data)}
              key={data.id}
              className={`py-1`}
              bgcolor={`${data.id === selected ? "active" : "bg-midnight"}`}
              content={
                <>
                  {data.image_url ? (
                    <img
                      src={data.image_url}
                      alt={data.name}
                      className="img-fluid chat-image user-img"
                    />
                  ) : (
                    <div
                      style={{ borderRadius: "4px 4px 0px 0px" }}
                      className={`default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center mx-auto chat-image ${
                        data.id === selected && "active-chat"
                      }`}
                    >
                      <i
                        className="fa-solid fa-user"
                        style={{ fontSize: 20 }}
                      ></i>
                    </div>
                  )}
                  <div
                    className={`chat-info d-flex align-items-center my-auto ${"light-purple-color"}`}
                  >
                    {data.is_read ? <div className="chat-active"></div> : null}
                    <div className="font-500-20 mb-0 ms-4">{data.name}</div>
                  </div>
                </>
              }
            />
          ))}
        </>
      )}
    </div>
  );
};

export default ChatList;
